import './style/App.scss';
import { Provider } from 'react-redux';
import { useStore } from './redux/store';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from './layout'
import Home from './layout/auth/home/Home'
import Forecast from './layout/auth/forecast/Forecast';
import ViewDay from '../src/layout/auth/viewDay/ViewDay'
import './index.css';
import { StylesProvider } from "@material-ui/core/styles";

const App = (): React.ReactElement => { 
  const store = useStore()  
  return (
    <Router>
      <StylesProvider injectFirst>
        <Provider store={store}>
          <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/forecast" element={<Forecast history={undefined} dt={''} />} />
            <Route path="/view" element={<ViewDay history={undefined} />} />
          </Routes>
          </Layout>
        </Provider>
      </StylesProvider>
    </Router>
  );
}

export default App;
